export const cleanPhoneNumber = (phoneNumber: string) => {
  const cleanNumber = phoneNumber.replace(/[^\d]/g, "");
  if (!cleanNumber || !/^\d{10,13}$/.test(cleanNumber)) {
    throw new Error("Invalid phone number format");
  }

  return cleanNumber.replace(/^(\+62|62|0)/g, "62");
};

const whatsapp = (phoneNumber: string, predefineMessage = "") => {
  window.open(
    `https://wa.me/${cleanPhoneNumber(phoneNumber)}?text=${encodeURIComponent(
      predefineMessage
    )}`,
    "_blank"
  );
};
export default whatsapp;
